export enum IActionItemTaskCenterCategoryTypeId {
  Strike = 4,
}
